.root {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  overflow: hidden;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  color: #fff;
  user-select: none;
  -webkit-user-select: none;
  line-height: 1;
  direction: ltr;
  cursor: none;
  outline: none;
  min-height: 180px;
  container-type: size;
}

.root * ,
.root *::before,
.root *::after {
  box-sizing: border-box;
}

.hover {
  cursor: default;
}

.root video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.root video::-webkit-media-controls {
  display: none !important;
}

/* Bottom bar */
.bottomBar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 7;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0;
  opacity: 0;
  transition: opacity 1s ease;
}

/* Controls-visible state: add gradient background */
.bottomBarControlsVisible {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 60%, transparent 100%);
}

.bottomBarVisible {
  opacity: 1;
  transition: opacity 1s ease;
}

.controls {
  --active-zone-inline-inset: 12px;
  display: flex;
  align-items: center;
  width: 100%;
  flex: 1;
  min-width: 0;
  min-height: 64px;
  max-height: 64px;
  padding-inline: var(--active-zone-inline-inset);
  gap: 0;
}

.controlsLeft {
  display: flex;
  align-items: center;
  gap: var(--spacing\/3, 24px);
}

/* Timeline row: fixed 14px container above the control bar.
   Track geometry (6px default, 8px on hover) lives in Timeline.module.css. */
.timelineRow {
  display: flex;
  align-items: center;
  width: 100%;
  height: 14px;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.bottomBarControlsVisible .timelineRow {
  margin-bottom: 0px;
}

.controlsRight {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: var(--spacing\/3, 24px);
}

.controlsHidden {
  display: none;
}

/* Fullscreen */
.fullscreen {
  position: fixed !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 2147483647 !important;
  border-radius: 0 !important;
}

/* Compact layout: reduce gaps/padding when the shell is narrow */
@container (max-width: 480px) {
  .controls {
    padding-inline: var(--active-zone-inline-inset);
  }

  .controlsLeft {
    gap: 4px;
  }

  .controlsRight {
    gap: 4px;
  }
}

@container (max-width: 320px) {
  .controls {
    padding-inline: var(--active-zone-inline-inset);
  }

  .controlsLeft {
    gap: 2px;
  }

  .controlsRight {
    gap: 2px;
  }
}

/* Wrapper around conditionally-hidden controls.
   display:contents makes the div transparent to flex layout —
   empty plugin slots consume no gap; registered plugin content
   flows directly as flex items with the normal gap. */
.compactHeightWrapper {
  display: contents;
}

/* Compact height tiers (180–379px): restore Figma-spec spacing
   (px-16px py-8px gap-24px) regardless of width-breakpoint overrides.
   Applies to both 334–379px and 180–333px tiers. */
@container (max-height: 379px) {
  .controls {
    padding-inline: var(--spacing\/2, 16px);
    padding-block: var(--spacing\/1, 8px);
  }

  .controlsLeft {
    gap: var(--spacing\/3, 24px);
  }

  .controlsRight {
    gap: var(--spacing\/3, 24px);
  }
}

/* Compact height tier (180–333px): hide non-essential controls,
   keep only Play, Volume (mute icon), Settings, Fullscreen. */
@container (max-height: 333px) {
  .compactHeightWrapper {
    display: none;
  }
}
